// const YTPlayer = require('yt-player');

class Video {

    constructor() {
        this.cacheDom();
        this.bindEvents();
        this.initVideoOnScroll();
    }

    cacheDom() {
        this.player = null;
        this.stateNames = {
            '-1': 'unstarted',
            0: 'ended',
            1: 'playing',
            2: 'paused',
            3: 'buffering',
            5: 'video cued',
        };
        this.playerType = null;
        this.container = document.querySelector('.c-video__block');
        this.playerButton = document.querySelector('.c-video__playBtn');
        this.playerElement = document.querySelector('#player');
        this.playerPoster = document.querySelector('.c-video__poster');
    }

    bindEvents() {
        if (_.isNull(this.playerButton) === false && _.isNull(this.container) === false && _.isNull(this.playerElement) === false) {
            this.playerButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.playerType = this.playerButton.getAttribute('data-player');
                const videoId = this.playerButton.getAttribute('data-videoId');
                this.initPlayer(videoId);
            });
        }
    }

    resize() {
        if (_.isUndefined(Breakpoint.grpInt) === false) {
            if (Breakpoint.grpInt > 3) {
                this.bindEvents();
                this.initVideoOnScroll();
            } else {
                this.bindEvents();
            }
        }
    }

    initVideoOnScroll() {
        if (_.isNull(this.container) === false) {
            const elementWatcher = scrollMonitor.create(this.container);
            elementWatcher.fullyEnterViewport(() => {
                this.playerButton.click();
            });

            elementWatcher.exitViewport(() => {
                this.pausePlayer();
            });
        }
    }

    initPlayer(videoId) {
        if (this.playerType === 'youtube') {
          this.youtubePlayer(videoId);
        } else {
          this.vimeoPlayer(videoId);
        }
    }

    youtubePlayer(videoId) {
        if (_.isNull(this.player)) {

            this.player = YouTubePlayer(this.playerElement);
            this.player.loadVideoById(videoId);

            this.player.on('stateChange', (event) => {
                if (!this.stateNames[event.data]) {
                    throw new Error(`Unknown state (${event.data}).`);
                }

                if (this.stateNames[event.data] === 'playing') {
                    this.playerPoster.classList.add('is-playing');
                    this.playerButton.classList.add('is-playing');
                }

                if (this.stateNames[event.data] === 'ended') {
                    this.playerPoster.classList.remove('is-playing');
                    this.playerButton.classList.remove('is-playing');
                }
            });
        }

        this.player.playVideo();
    }

    onPlayerReady(event) {
        event.target.playVideo();
    }

    onPlayerStateChange() {
        console.log('state has changed');
    }

    vimeoPlayer(videoId) {
        if (_.isNull(this.player)) {
            this.player = new Vimeo.Player(this.playerElement, {
                id: videoId,
                autoplay: 0,
                title: 0,
                byline: 0,
                portrait: 0,
                background: 1,
            });
        }

        this.player.play();
        this.player.ready().then(() => {
            this.playerPoster.classList.add('is-playing');
            this.playerButton.classList.add('is-playing');
        });

        this.player.on('ended', () => {
            this.playerPoster.classList.remove('is-playing');
            this.playerButton.classList.remove('is-playing');
        });
    }

    pausePlayer() {
        if (_.isNull(this.player) === false) {
           
            if (this.playerType === 'youtube') {
                this.player.stopVideo();
            } else {
                this.player.pause();
            }
          
           this.playerPoster.classList.remove('is-playing');
           this.playerButton.classList.remove('is-playing');
        }
    }
}

module.exports = Video;